import { render, staticRenderFns } from "./coursepackagesRecycleBin.vue?vue&type=template&id=1d9350c4&scoped=true&"
import script from "./coursepackagesRecycleBin.vue?vue&type=script&lang=js&"
export * from "./coursepackagesRecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./coursepackagesRecycleBin.vue?vue&type=style&index=0&id=1d9350c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9350c4",
  null
  
)

export default component.exports